import { onMounted, ref, getCurrentInstance } from 'vue'

export default function () {
  const couponList = ref([])

  const { proxy } = getCurrentInstance()

  async function getCoupons() {
    const res = await proxy.$http({
      type: 'get',
      url: '/coupon/lists',
      params: {
        page: 1,
        limit: 100,
      },
    })
    if (res.code == 0) {
      couponList.value = [{ id: 0, name: '无配置' }, ...res.data.data]
    }
  }

  onMounted(() => {
    getCoupons()
  })

  function getCouponName(id) {
    const temp = couponList.value.find((item) => id == item.id)
    if (temp) {
      return temp.name
    } else {
      return ''
    }
  }

  return { couponList, getCouponName }
}
